import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import {
  PageHeadingStyled as PageHeading,
  PageTitleStyled as PageTitle,
  IconStyled,
} from './styles/PageNavStyled';
import AppContext from '../../App/AppContext';
import { ReactComponent as ArrowLeft } from '../../../images/arrow-left.svg';

const PageNav = ({ title, to, startIcon, onClick, level, className }) => {
  const { setShowNavbar } = useContext(AppContext);

  useEffect(() => {
    setShowNavbar(level !== 'second');
  }, []);

  const HeadingComponent = to ? Link : PageHeading;
  const IconComponent = startIcon === undefined ? ArrowLeft : null;
  return (
    <PageHeading as={HeadingComponent} to={to} onClick={onClick}>
      {IconComponent && <IconStyled as={IconComponent} />}
      <PageTitle className={className}>{title}</PageTitle>
    </PageHeading>
  );
};

PageNav.propTypes = {
  title: PropTypes.node.isRequired,
  to: PropTypes.string,
  startIcon: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  level: PropTypes.oneOf(['first', 'second']),
};

PageNav.defaultProps = {
  to: undefined,
  startIcon: undefined,
  onClick: undefined,
  className: '',
  level: undefined,
};

export default PageNav;
